import _ from 'lodash';
import { DependencyError } from './errors';

const EMAIL_ADDRESS_REGEX = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;

const isBlankString = (value) => _.isString(value) && _.isEmpty(value.trim());

export const isBlank = (value) => _.isEmpty(value) || isBlankString(value);

export const isEmail = (value) => EMAIL_ADDRESS_REGEX.test(value);

export const withTimeout = (ms, promise) =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new DependencyError('TIMEOUT'));
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((reason) => {
        clearTimeout(timer);
        reject(reason);
      });
  });
